// extracted by mini-css-extract-plugin
export default {"sectionTwoCol2":"styles_sectionTwoCol2__Np8rV","sectionTwoContainer":"styles_sectionTwoContainer__FkG5L","sectionTwoCol1":"styles_sectionTwoCol1__NkvOg"};